/**
 * DevExtreme (esm/ui/data_grid/ui.data_grid.filter_sync.js)
 * Version: 22.1.4
 * Build date: Fri Jul 22 2022
 *
 * Copyright (c) 2012 - 2022 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
import core from "./ui.data_grid.core";
import {
    filterSyncModule
} from "../grid_core/ui.grid_core.filter_sync";
core.registerModule("filterSync", filterSyncModule);
